<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ក ៥.ខ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ៥.គ ៥.ឃ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ៥.ង​ ៥.ច
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ៥.ឆ​ ៥.ជ
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <schoolarea :data="fac_5a" :last_row="1" :title="title[1]" />
          </div>
          <div><schoolconst :data="fac_5b" :title="title[2]" /></div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <div><schoolbuilding :data="fac_5c" :title="title[3]" /></div>
            <div>
              <handwashing :data="utl_5d" :lastRow="1" :title="title[4]" />
            </div>
            <!-- LastRow is 1 for pri and sec school-->
          </div>
          <div>
            <p></p>
            <schoolroom :data="fac_5cc" />
            <!-- No title on the form -->
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div>
          <toilet :data="utl_5e" :title="title[5]" />
          <water :data="utl_5f" :title="title[6]" />
        </div>
      </v-tab-item>
      <v-tab-item>
        <div>
          <facility :data1="utl_g1" :data2="utl_g2" :title="title[7]" />
          <schoolsport :fdata="utl_5h1" :sdata="utl_5h2" :title="title[8]" />
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import schoolArea from "@/components/ascf/sharedCom/schoolArea.vue";
import schoolConst from "@/components/ascf/sharedCom/schoolConstruction.vue";
import schoolBuilding from "@/components/ascf/sharedCom/schoolBuilding.vue";
import schoolRoom from "@/components/ascf/sharedCom/schoolRoom.vue";
import handWashing from "@/components/ascf/sharedCom/handwashing.vue";
import toilet from "@/components/ascf/sharedCom/toilet.vue";
import Facility from "@/components/ascf/sharedCom/facility.vue";
import WaterSource from "@/components/ascf/sharedCom/waterSource.vue";
import schoolSport from "@/components/ascf/sharedCom/schoolSport.vue";

export default {
  props: [
    "title",
    "fac_5a",
    "fac_5b",
    "fac_5c",
    "fac_5cc",
    "utl_5d",
    "utl_5e",
    "utl_5f",
    "utl_g1",
    "utl_g2",
    "utl_5h1",
    "utl_5h2",
  ],
  components: {
    schoolarea: schoolArea,
    schoolconst: schoolConst,
    schoolbuilding: schoolBuilding,
    schoolroom: schoolRoom,
    handwashing: handWashing,
    toilet: toilet,
    facility: Facility,
    water: WaterSource,
    schoolsport: schoolSport,
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  methods: {},
};
</script>
<style scoped>
.row {
  display: flex;
}
.col {
  display: flex;
  flex-direction: column;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>